<button pButton [label]="labelBtn" icon="pi pi-file-excel" (click)="exportToExcel()"></button>